import { Route, Routes } from "react-router-dom";
import { PublicRoute } from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import LoginScreen from "../pages/auth/LoginScreen";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ForgotOTP from "../pages/auth/ForgotOTP";
import ResetPassword from "../pages/auth/ResetPassword";
import Dashboard from "../pages/dashboard/Dashboard";
import DashboardDetails from "../pages/dashboard/DashboardDetails";
import LeaderBoard from "../pages/LeaderBoard";
import ProfileScreen from "../pages/ProfileScreen";
import EndJob from "../pages/endJob/EndJob";
import Rewards from "../pages/rewards/Rewards";
import RedeemDetails from "../pages/rewards/RedeemDetails";
import PointHistory from "../pages/pointHistory/PointHistory";
import LearningList from "../pages/learningCenter/LearningList";
import ReadMore from "../pages/learningCenter/ReadMore";
import EndJobDetails from "../pages/endJob/EndJobDetails";
import ChatList from "../pages/chat/ChatList";
import NewChatist from "../pages/chat/NewChatist";
import ChatScreen from "../pages/chat/ChatScreen";
import TermsConditiion from "../pages/TermsConditiion";
import AboutUs from "../pages/AboutUs";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";
import WorkLog from "../pages/WorkLog";
import NotFound from "../pages/NotFound";
import DeleteAccount from "../pages/auth/DeleteAccount";

const AppRouter = () => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <LoginScreen />
            </PublicRoute>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginScreen />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/verify-otp"
          element={
            <PublicRoute>
              <ForgotOTP />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-pass"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/details"
          element={
            <ProtectedRoute>
              <DashboardDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <ProtectedRoute>
              <LeaderBoard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfileScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/end-job"
          element={
            <ProtectedRoute>
              <EndJob />
            </ProtectedRoute>
          }
        />
        <Route
          path="/end-job-details"
          element={
            <ProtectedRoute>
              <EndJobDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rewards"
          element={
            <ProtectedRoute>
              <Rewards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reward-redeem"
          element={
            <ProtectedRoute>
              <RedeemDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/points-history"
          element={
            <ProtectedRoute>
              <PointHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/learning-list"
          element={
            <ProtectedRoute>
              <LearningList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/read-learning"
          element={
            <ProtectedRoute>
              <ReadMore />
            </ProtectedRoute>
          }
        />

        <Route
          path="/chat-list"
          element={
            <ProtectedRoute>
              <ChatList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/new-chat-list"
          element={
            <ProtectedRoute>
              <NewChatist />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chats"
          element={
            <ProtectedRoute>
              <ChatScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/terms-condition"
          element={
            <ProtectedRoute>
              <TermsConditiion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/terms"
          element={
            <PublicRoute>
              <Terms />
            </PublicRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <ProtectedRoute>
              <PrivacyPolicy />
            </ProtectedRoute>
          }
        />
        <Route
          path="/privacy"
          element={
            <PublicRoute>
              <Privacy />
            </PublicRoute>
          }
        />
        <Route
          path="/about-us"
          element={
            <ProtectedRoute>
              <AboutUs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clock"
          element={
            <ProtectedRoute>
              <WorkLog />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRouter;
